export class AuthConstant {
  public static readonly TOKEN_TYPE_KEY = "Bearer ";
  public static readonly ACCESS_TOKEN = "access_token";
  public static readonly REMEMBER_LOGIN = "remember";
  public static readonly EXPIRES_REMEMBER = 365; //day
  public static readonly EXPIRES_TOKEN = 1;
  public static readonly _TOKEN = "accessToken";
  public static readonly PUBLIC_KEY = "publicKey";

  public static readonly USER_UID_HAS_ROLE_R000 = "20221214090920003";
  public static readonly USER_UID_HAS_ROLE_R001 = "20221213150337001";
  public static readonly USER_UID_HAS_ROLE_R002 = "test";
  public static readonly USER_UID_HAS_ROLE_R002_1 = "test_user1";
  public static readonly USER_UID_HAS_ROLE_R003 = "20221214090920005";

  // 임시
  public static readonly USER = "USER";
  public static readonly ADMIN = "ADMIN";    // 관리자
  public static readonly R001 = "R001";    // 일반사용자(산단기업)
  public static readonly R002 = "R002";    // 중개업자(전력판매)
  public static readonly R005 = "R005";    // DC그리드 사용자

  public static formatUserId(e: any) {
    switch (e) {
      case AuthConstant.USER_UID_HAS_ROLE_R000:
        return '산단관리자';
      case AuthConstant.USER_UID_HAS_ROLE_R001:
        return '테스트기업';
      case AuthConstant.USER_UID_HAS_ROLE_R002:
        return '재생E공급자';
      case AuthConstant.USER_UID_HAS_ROLE_R003:
        return 'XX 기업';
      default:
        return 'test-user1';
    }
  }
}